
  let LMap, LTileLayer, LMarker;
  if (process.client) {
    require('leaflet');
    ({
      LMap,
      LTileLayer,
      LMarker,
    } = require('vue2-leaflet/dist/vue2-leaflet.min'));

    // eslint-disable-next-line
    delete L.Icon.Default.prototype._getIconUrl;
    // eslint-disable-next-line
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
  }
  import 'leaflet/dist/leaflet.css';
  import ScreenSize from '@/mixins/ScreenSize';

  export default {
    name: 'ElementJobDetailsLocationCard',
    components: {
      LMap,
      LTileLayer,
      LMarker,
    },
    filters: {
      empty_default: function (value) {
        if (!value || value === '') {
          return 'k.A.';
        } else {
          return value;
        }
      },
    },
    mixins: [ScreenSize],
    props: {
      job: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        currentLocation: {},
        locations: [],
        cities: [],
        numberOfRows: 0,
        citiesNumberPerRow: 10,
        openStreetMapUrl: process.env.NUXT_ENV_OPEN_STREET_MAPS_TILE,
      };
    },
    created() {
      Object.keys(this.job.locations).map((key) => {
        if (this.job.locations[key].city) {
          this.cities.push(this.job.locations[key].city);
          this.locations.push(this.job.locations[key]);
        }
      });
      this.cities = this.cities.sort();
      if (this.cities.length > 10) {
        if (this.isMobile) {
          this.citiesNumberPerRow = Math.ceil(this.cities.length / 2);
        } else {
          this.citiesNumberPerRow = Math.ceil(this.cities.length / 3);
        }
      } else {
        this.citiesNumberPerRow = this.cities.length;
      }
      this.numberOfRows = this.isMobile ? 2 : 3;
    },
  };
